import {
  META_GENDER,
  META_GENDER_SELECTION,
  type MetaGender,
  type MetaGenderSelection,
} from './const';

// The backend has no "all" gender — targeting everyone is an empty list — so a stored facet maps
// back onto the form's three-way choice rather than round-tripping a value.
export const getMetaGenderSelection = (genders: MetaGender[]): MetaGenderSelection => {
  const men = genders.includes(META_GENDER.male);
  const women = genders.includes(META_GENDER.female);

  if (men && !women) {
    return META_GENDER_SELECTION.men;
  }
  if (women && !men) {
    return META_GENDER_SELECTION.women;
  }
  return META_GENDER_SELECTION.all;
};
